import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import Activate from 'pages/Activate';
import Admin from 'pages/Admin';
import Anomalies from 'pages/Anomalies';
import AuthCallback from 'pages/AuthCallback';
import BusinessProfile from 'pages/BusinessProfile';
import CashEngine from 'pages/CashEngine';
import Dashboard from 'pages/Dashboard';
import Element from 'pages/Element';
import Env from 'pages/Env';
import ExternalSignals from 'pages/ExternalSignals';
import FinancialSettings from 'pages/FinancialSettings';
import Help from 'pages/Help';
import Home from 'pages/Home';
import KnowYourData from 'pages/KnowYourData';
import Login from 'pages/Login';
import MarginEngine from 'pages/MarginEngine';
import Memory from 'pages/Memory';
import Notifications from 'pages/Notifications';
import Profile from 'pages/Profile';
import SalesEngine from 'pages/SalesEngine';
import Thread from 'pages/Thread';
import Today from 'pages/Today';
import YourData from 'pages/YourData';

import Shell from '@/components/header/Shell';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: (
        <Shell>
          <Home />
        </Shell>
      )
    },
    {
      path: '/today',
      element: (
        <Shell>
          <Today />
        </Shell>
      )
    },
    {
      path: '/env',
      element: <Env />
    },
    {
      path: '/thread/:id?',
      element: (
        <Shell>
          <Thread />
        </Shell>
      )
    },
    {
      path: '/element/:id',
      element: <Element />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/activate',
      element: <Activate />
    },
    {
      path: '/login/callback',
      element: <AuthCallback />
    },
    {
      path: '/share/:id',
      element: <Thread />
    },
    {
      path: '/dashboard',
      element: (
        <Shell>
          <Dashboard />
        </Shell>
      )
    },
    {
      path: '/anomalies',
      element: (
        <Shell>
          <Anomalies />
        </Shell>
      )
    },
    {
      path: '/external-signals',
      element: (
        <Shell>
          <ExternalSignals />
        </Shell>
      )
    },
    {
      path: '/financial-settings',
      element: (
        <Shell>
          <FinancialSettings />
        </Shell>
      )
    },
    {
      path: '/admin',
      element: (
        <Shell>
          <Admin />
        </Shell>
      )
    },
    {
      path: '/notifications',
      element: (
        <Shell>
          <Notifications />
        </Shell>
      )
    },
    {
      path: '/help',
      element: (
        <Shell>
          <Help />
        </Shell>
      )
    },
    {
      path: '/memory',
      element: (
        <Shell>
          <Memory />
        </Shell>
      )
    },
    {
      path: '/profile',
      element: (
        <Shell>
          <Profile />
        </Shell>
      )
    },
    {
      path: '/cash',
      element: (
        <Shell>
          <CashEngine />
        </Shell>
      )
    },
    {
      path: '/sales',
      element: (
        <Shell>
          <SalesEngine />
        </Shell>
      )
    },
    {
      path: '/margin',
      element: (
        <Shell>
          <MarginEngine />
        </Shell>
      )
    },
    {
      path: '/data',
      element: (
        <Shell>
          <YourData />
        </Shell>
      )
    },
    {
      path: '/know-your-data',
      element: (
        <Shell>
          <KnowYourData />
        </Shell>
      )
    },
    {
      path: '/business-profile',
      element: (
        <Shell>
          <BusinessProfile />
        </Shell>
      )
    },
    {
      path: '*',
      element: <Navigate replace to="/" />
    }
  ],
  { basename: getRouterBasename() }
);
